import { useState } from "react";
import {
  TextField,
  Menu,
  MenuItem,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import LinkIcon from "@mui/icons-material/Link";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import styles from "../../ProductsRPDesigner.module.scss";

function InputSetting({
  valueIndex,
  components,
  setComponents,
  selectedComponentIndex,
  selectedLanguage,
  attributes,
}) {
  const [contextMenu, setContextMenu] = useState(null);
  const [contextMenuIndex, setContextMenuIndex] = useState(0);
  const [selectedInputName, setSelectedInputName] = useState(undefined);
  const [openLink, setOpenLink] = useState(false);
  const [url, setUrl] = useState(true);
  const [email, setEmail] = useState(false);
  const [text, setText] = useState(false);
  const [bold, setBold] = useState(false);
  const [link, setLink] = useState({
    url: "",
    desc: "",
    subject: "",
    body: "",
    color: "#000000",
  });



  const menuItems = attributes.map((a) => {
    return (
      <MenuItem
        key={a.label}
        id={a.label}
        onClick={(e) => handleClose(e)}
      >
        {a.labelText}
      </MenuItem>
    );
  });

  const handleContextMenu = (event, name) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
          // Other native context menus might behave different.
          // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
          null
    );

    setSelectedInputName(name);
    setContextMenuIndex(event.target.selectionStart);
  };

  const handleCloseLink = () => {
    setOpenLink(false);
  };

  const handleClose = (e) => {
    const { id } = e.target;

    if (selectedInputName !== undefined) {
      setSelectedInputName(undefined);

      const newVal =
        link[selectedInputName].slice(0, contextMenuIndex) +
        "{" +
        id +
        "}" +
        link[selectedInputName].slice(contextMenuIndex);

      handleChangeLink({ target: { value: newVal } }, selectedInputName);

    } else if (id) {

      const newVal =
        components[selectedComponentIndex].value[valueIndex].languages[
          selectedLanguage
        ].slice(0, contextMenuIndex) +
        "{" +
        id +
        "}" +
        components[selectedComponentIndex].value[valueIndex].languages[
          selectedLanguage
        ].slice(contextMenuIndex);

      setComponents((prev) => {
        return prev.map((p, index) => {
          if (index === selectedComponentIndex) {
            const valueObj = p.value.map((obj, index) => {
              if (index === valueIndex) {
                return {
                  ...obj,
                  languages: {
                    ...obj.languages,
                    [selectedLanguage]: newVal,
                  },
                };
              }

              return obj;
            });

            return {
              ...p,
              value: valueObj,
            };
          }

          return p;
        });
      });
    }


    setContextMenu(null);
  };

  function handleChange(value) {
    setComponents((prev) => {
      return prev.map((p, index) => {
        if (index === selectedComponentIndex) {
          const valueObj = p.value.map((obj, index) => {
            if (index === valueIndex) {
              return {
                ...obj,
                languages: {
                  ...obj.languages,
                  [selectedLanguage]: value,
                },
              };
            }

            return obj;
          });

          return {
            ...p,
            value: valueObj,
          };
        }

        return p;
      });
    });
  }

  function copyValue() {
    handleChange(
      components[selectedComponentIndex]?.value[valueIndex].languages?.["en"]
    );
  }

  function deleteValue(e) {
    setComponents((prev) => {
      return prev.map((p, index) => {
        if (index === selectedComponentIndex) {
          let values = [...p.value];
          values.splice(valueIndex, 1);

          return {
            ...p,
            value: values,
          };
        }

        return p;
      });
    });
  }

  function openLinkPopup(e) {
    setLink({
      url: "",
      desc: "",
      subject: "",
      body: "",
      color: "#000000",
    });
    setUrl(true);
    setEmail(false);
    setText(false);
    setBold(false);

    setOpenLink(true);
  }

  function handleChangeCheckbox(e) {
    const { name, checked } = e.target;

    if (name === "url") {
      setUrl(checked);
      if (checked) {
        setEmail(false);
        setText(false);
      }
    } else if (name === "email") {
      setEmail(checked);
      if (checked) {
        setUrl(false);
        setText(false);
      }
    } else if (name === "text") {
      setText(checked);
      if (checked) {
        setUrl(false);
        setEmail(false);
      }
    } else if(name === "bold"){
      setBold(checked);
    }
  }

  function handleChangeLink(e, name) {
    const { value } = e.target;
    setLink((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  }

  function addLink(e) {
    var linkStr = "";
    if (text) {
      linkStr = "$TEXT[" + bold + ";" + link.desc + ";" + link.color + "]";
    } else if (url) {
      linkStr = "$LINK[" + link.url + ";" + link.desc + ";" + link.color + "]";
    } else if (email) {
      linkStr =
        "$MAIL[" +
        link.url +
        ";" +
        link.desc +
        ";" +
        link.color +
        ";" +
        link.subject +
        ";" +
        link.body +
         "]";
    }

    handleChange(
      (components[selectedComponentIndex]?.value[valueIndex].languages?.[
        selectedLanguage
      ] || "") + linkStr
    );

    setOpenLink(false);
  }

  function addUrl(e) {
    setComponents((prev) => {
      return prev.map((p, index) => {
        if (index === selectedComponentIndex) {
          const sValue = p.value.filter((val) => val.name === "url");
          if (sValue.length === 0) {
            return {
              ...p,
              value: [
                ...p.value,
                {
                  name: "url",
                  label: "Url",
                  languages: {
                    en: "",
                  },
                },
              ],
            };
          }
        }

        return p;
      });
    });
  }

  function removeUrl(e) {
    setComponents((prev) => {
      return prev.map((p, index) => {
        if (index === selectedComponentIndex) {
          const sValue = p.value.filter((val) => val.name !== "url");
          return {
            ...p,
            value: sValue,
          };
        }

        return p;
      });
    });
  }

  function isUrlPresent() {
    const sValue = components[selectedComponentIndex]?.value.filter(
      (val) => val.name === "url"
    );

    return sValue.length > 0;
  }

  return (
    <div
      key={components[selectedComponentIndex]?.value[valueIndex].name}
      style={{ display: "flex", flowDirection: "row" }}
    >
      <TextField
        id="outlined-multiline-flexible"
        label={components[selectedComponentIndex]?.value[valueIndex].label}
        multiline
        value={
          components[selectedComponentIndex]?.value[valueIndex].languages?.[
            selectedLanguage
          ] || ""
        }
        onChange={(e) => handleChange(e.target.value)}
        onContextMenu={handleContextMenu}
        fullWidth
      />

      {components[selectedComponentIndex]?.name === "image" && !isUrlPresent() && (
        <Tooltip title="Add Link">
          <IconButton onClick={(e) => addUrl(e)}>
            <LinkIcon />
          </IconButton>
        </Tooltip>
      )}

      {components[selectedComponentIndex]?.value[valueIndex]?.name ===
        "url" && (
        <Tooltip title="Remove Link">
          <IconButton onClick={(e) => removeUrl(e)}>
            <RemoveCircleIcon />
          </IconButton>
        </Tooltip>
      )}
      {components[selectedComponentIndex]?.name === "description" && (
        <Tooltip title="Add Link/E-Mail/Text">
          <IconButton onClick={(e) => openLinkPopup(e)}>
            <LinkIcon />
          </IconButton>
        </Tooltip>
      )}

      {components[selectedComponentIndex]?.name === "gallery" && (
        <IconButton onClick={(e) => deleteValue(e)}>
          <RemoveCircleIcon />
        </IconButton>
      )}

     {components[selectedComponentIndex]?.name === "slotmachine" && 
     components[selectedComponentIndex]?.value[valueIndex]?.name === "image" && (
        <IconButton onClick={(e) => deleteValue(e)}>
          <RemoveCircleIcon />
        </IconButton>
      )}

      {selectedLanguage !== "en" && (
        <IconButton title="copy from EN" onClick={(e) => copyValue()}>
          <MoveDownIcon />
        </IconButton>
      )}

      <Menu
        open={contextMenu !== null}
        onClose={(e) => handleClose(e)}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
      >
        {menuItems}
      </Menu>

      <Dialog open={openLink} onClose={handleCloseLink}>
        <DialogTitle>Add Link/E-Mail/Text</DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <FormControlLabel
            control={
              <Checkbox
                name="url"
                checked={url}
                onChange={(e) => handleChangeCheckbox(e)}
              />
            }
            label="Url"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="email"
                checked={email}
                onChange={(e) => handleChangeCheckbox(e)}
              />
            }
            label="E-Mail"
          />
          <FormControlLabel
            control={
              <Checkbox
                name="text"
                checked={text}
                onChange={(e) => handleChangeCheckbox(e)}
              />
            }
            label="Text"
          />

          {text === false ? (
            <TextField
              margin="dense"
              id="url"
              label={email ? "Email Address" : "URL"}
              type={email ? "email" : "input"}
              value={link?.url}
              onChange={(e) => handleChangeLink(e, "url")}
              fullWidth
              variant="standard"
            />
          ) : (
            <FormControlLabel
              fullWidth
              control={
                <Checkbox
                  name="bold"
                  checked={bold}
                  onChange={(e) => handleChangeCheckbox(e)}
                />
              }
              label="Bold"
            />
          )}
          <TextField
            margin="dense"
            id="desc"
            label="Description"
            type="input"
            value={link?.desc}
            onChange={(e) => handleChangeLink(e, "desc")}
            fullWidth
            variant="standard"
            onContextMenu={(e) => handleContextMenu(e, "desc")}       
          />
          {email && <TextField
            margin="dense"
            id="subject"
            label="Subject"
            type="input"
            value={link?.subject}
            onChange={(e) => handleChangeLink(e, "subject")}
            fullWidth
            variant="standard"
            onContextMenu={(e) => handleContextMenu(e, "subject")}
          />}
          {email && < TextField
            margin="dense"
            id="body"
            label="Body"
            type="input"
            value={link?.body}
            onChange={(e) => handleChangeLink(e, "body")}
            fullWidth
            variant="standard"
            onContextMenu={(e)=> handleContextMenu(e,"body")}
          />}
          <div
            className={styles["sec--products--rpdesigner--colors--element"]}
            style={{ paddingTop: "20px" }}
          >
            <div
              className={
                styles["sec--products--rpdesigner--colors--element--left"]
              }
            >
              Color:
            </div>
            <div>
              <input
                id="color"
                type="color"
                value={link?.color}
                onChange={(e) => handleChangeLink(e, "color")}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseLink}>Cancel</Button>
          <Button onClick={addLink}>Add</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default InputSetting;
